import { c as _c } from "react/compiler-runtime";
import React from "react";
export const LogoIcon = t0 => {
  const $ = _c(6);
  const {
    className: t1
  } = t0;
  const className = t1 === undefined ? "w-8 h-8" : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <stop offset="0%" stopColor="#0F172A" />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <stop offset="45%" stopColor="#2563EB" />;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <defs><linearGradient id="notreimmeuble-gradient" x1="0%" y1="100%" x2="100%" y2="0%">{t2}{" "}{t3}{" "}<stop offset="100%" stopColor="#2DD4BF" /> </linearGradient></defs>;
    t5 = <path fill="url(#notreimmeuble-gradient)" d="M277.773 0C404.082 2.276 512.31 80.12 546.346 203.734C556.192 239.492 554.699 268.575 554.692 305.164L554.679 380.048L554.69 599.428L459.622 599.355L459.662 595.943L459.71 377.958L459.733 306.187C459.736 279.208 461.184 255.17 454.83 228.736C447.157 197.736 431.159 169.423 408.563 146.855C374.036 112.167 327.283 92.401 278.344 91.802C184.134 90.765 99.3828 165.981 94.8898 261.148C94.2548 274.595 94.6378 288.838 94.6308 302.353L94.6138 368.016L94.4768 599.32C63.6638 599.943 31.1338 599.428 0.213829 599.427L0.214821 391.072L0.192818 305.584C0.168818 285.83 -0.645175 260.894 1.26283 241.613C7.00983 183.521 34.6258 127.59 74.8538 85.599C118.418 40.64 175.726 11.484 237.716 2.743C251.364 0.804996 264.034 0.288 277.773 0Z" />;
    $[2] = t4;
    $[3] = t5;
  } else {
    t4 = $[2];
    t5 = $[3];
  }
  let t6;
  if ($[4] !== className) {
    t6 = <svg viewBox="0 0 555 600" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} aria-hidden="true">{t4}{t5}</svg>;
    $[4] = className;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  return t6;
};